var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWarningSign = function SvgWarningSign(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.62 4.487c.347-.65 1.412-.65 1.761 0l7.5 14a.994.994 0 0 1-.024.988.99.99 0 0 1-.857.485H4.001a.992.992 0 0 1-.858-.486.991.991 0 0 1-.023-.986l7.498-14h.001Zm.88.473-7.499 14h15l-7.5-14Zm.5 11v1h-1v-1h1Zm0-6v5h-1v-5h1Z",
    fill: "#FFB600"
  })));
};
export default SvgWarningSign;